export default {
  en: {
    home: 'Home',
    vocabulary: 'Vocabulary',
    statistics: 'Statistics',
    profile: 'Profile',
    navigation: 'Main navigation',
  },
  ru: {
    home: 'Главная',
    vocabulary: 'Словарь',
    statistics: 'Аналитика',
    profile: 'Профиль',
    navigation: 'Основная навигация',
  },
  de: {
    home: 'Start',
    vocabulary: 'Vokabeln',
    statistics: 'Statistiken',
    profile: 'Profil',
    navigation: 'Hauptnavigation',
  },
  pt: {
    home: 'Início',
    vocabulary: 'Vocabulário',
    statistics: 'Estatísticas',
    profile: 'Perfil',
    navigation: 'Navegação principal',
  },
  fr: {
    home: 'Accueil',
    vocabulary: 'Vocabulaire',
    statistics: 'Statistiques',
    profile: 'Profil',
    navigation: 'Navigation principale',
  },
  es: {
    home: 'Inicio',
    vocabulary: 'Vocabulario',
    statistics: 'Estadísticas',
    profile: 'Perfil',
    navigation: 'Navegación principal',
  },
};
